<template>
  <div>
    <el-form-item :label="translateText('textMap.','类型选择:')" style="min-height: 32px;margin:0 8px 8px 8px">
      <el-select v-model="treeData.type" :placeholder="translateText('textMap.', '请选择类型')" @change="typeChange" :no-data-text="translateText('textMap.', '无数据')">
        <el-option v-for="type in types" :label="translateText('textMap.', type.label)" :value="type.label" :key="type.label"></el-option>
      </el-select>
    </el-form-item>

  <div class="ReciprocatOverviewTree" ref="ui">
    <el-tree :data="reciprocateTree" show-checkbox v-disable-arrow-toggle :render-content="renderContent" default-expand-all ref="recComTree"
             node-key="id" @check="pointTreeChecked"  :empty-text="translateText('textMap.', '无数据')"></el-tree>
  </div>
  </div>
</template>

<script>
  import keepAliveMixin from "@/mixins/keepAliveMixin";

  export default {
    mixins: [keepAliveMixin],
    name: "ReciprocatOverviewTree",
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'label',
          disabled: function(data, node) {
            if(node.store.getCheckedKeys(true).length >= 9) {
              return node.store.getCheckedKeys(true).indexOf(data.id) < 0
            }
          }
        },
        treeData: {
          type: "",
          feature: 0,
          //  cylinderNo: -1,  缸号选择
          pointIdString: "",
          Type: 99,
          channelType: null
        },
        Type: {
          100: "壳体振动",
          101: "曲轴箱振动",
          113: "其它振动",
        },
        channelType: {
          3: "压力",
          4: "温度",
          5: "流量",
          6: "其它",
          7: "撞击",
          11: "动态压力",
          12: "活塞杆沉降/偏摆",
        },
        // 用于显示的types挑选
        // types: [
        //   {label:"壳体振动"},
        //   {label: "曲轴箱振动"},
        //   {label: "动态压力"},
        //   {label: "活塞杆沉降/偏摆"},
        //   {label: "温度"},
        //   {label: "撞击"},
        //   {label: "其它振动"},
        // ],
        reciprocateTree: [],
        NowPointsData:[],
        mycolor: '#ffffff',
        nowType: '',
        first: true,
        pointSelectList: {
          '壳体振动': [],
          '曲轴箱振动': [],
          '其它振动': [],
          '活塞杆沉降/偏摆': [],
          '动态压力': [],
          '温度': [],
          '撞击': [],
          "压力": [],
          "流量": [],
          '其它': [],
        },//保存各类测点选中的顺序
        firstLoad: true,//第一次不执行activated，避免冲突
        allPoints: [], //记录振动测点信息
        otherPoints: [], //记录其它信息
      };
    },

    mounted() {
      this.mycolor = this.$store.state.textcolor;
      this.$refs.ui.style.setProperty('--pointcolor', this.$store.state.pointcolor);
      this.$refs.ui.style.setProperty('--eltreecolor', this.$store.state.eltreecolor);
      this.$refs.ui.style.setProperty('--textcolor', this.$store.state.textcolor);
      this.$refs.ui.style.setProperty('--eltreebordercolor', this.$store.state.eltreebordercolor);
      let interval = setInterval(()=>{
        if(this.nodeData[this.equid] !== undefined){
          clearInterval(interval)
          this.getPointTree(this.equid);
        }
      },500)
    },
    activated() {
      this.activatedFlag = true
      this.$store.state.globalTreeSelect = "0"
      if(!this.firstLoad){
        this.syncGlobalPoint()
      }
      this.firstLoad = false
    },
    deactivated() {
      this.activatedFlag = false
    },
    computed: {
      nodeData() {
        return this.$store.state.equipmentDetail;
      },
      equid() {
        return this.$store.state.equid;
      },
      nodeNum() {
        return this.$store.state.detailNum;
      },
      topiccolor() {
        return this.$store.state.topiccolor;
      },
      globalPointId(){
        return this.$store.state.globalPointId
      },
      globalTreeSelect(){
        return this.$store.state.globalTreeSelect
      },
      types(){

        // 用于显示的types挑选
        let myTypes = [
          {label: "壳体振动"},
          {label: "曲轴箱振动"},
          {label: "其它振动"},
          {label: "活塞杆沉降/偏摆"},
          {label: "动态压力"},
          {label: "温度"},
          {label: "撞击"},
          {label: "压力"},
          {label: "流量"},
          {label: "其它"},
        ];

        // 接口中的数字和现实的不一样，需要做一个区分
        let myTypesMap = [
          {
            label: "壳体振动",
            channelType: 1,
            type: 100,
          },{
            label: "曲轴箱振动",
            channelType: 1,
            type: 100,
          },{
            label: "其它振动",
            channelType: 1,
            type: 100,
          },{
            label: "活塞杆沉降/偏摆",
            channelType: 12,
            type: 112
          },{
            label: "动态压力",
            channelType: 11,
            type: 111
          },{
            label: "温度",
            channelType: 4,
            type: 99
          },{
            label: "撞击",
            channelType: 7,
            type: 99
          },{
            label: "压力",
            channelType: 3,
            type: 99
          },{
            label: "流量",
            channelType: 5,
            type: 99
          },{
            label: "其它",
            channelType: 6,
            type: 99
          },
        ]
        var useTypes = [];
        let treeData =  this.nodeData[this.$store.state.equid]
        if (treeData != undefined){
          for (let i = 0; i < myTypes.length; i++) {
            let temp = [];
            if(myTypes[i].label == "壳体振动"){
              temp = treeData.filter(item => item.channelType == 1 && (item.cylinderNo >= 1 && item.cylinderNo <= 100))
            }else if(myTypes[i].label == "曲轴箱振动"){
              temp = treeData.filter(item => item.channelType == 1 && item.cylinderNo == 0)
            }else if(myTypes[i].label == "其它振动"){
              temp = treeData.filter(item => item.channelType == 1 && item.cylinderNo > 100)
            }else{
              temp = treeData.filter(item => item.channelType == myTypesMap[i].channelType && item.type == myTypesMap[i].type)
            }
            if (temp.length > 0){
              useTypes.push(myTypes[i])
            }
          }
        }
        if(this.treeData.type == '') {
          this.treeData.type = useTypes.length ? useTypes[0].label : ''
        }
        return useTypes
      }
    },

    watch: {
      topiccolor(val) {
        this.mycolor = this.$store.state.textcolor;
        this.$refs.ui.style.setProperty('--pointcolor', this.$store.state.pointcolor);
        this.$refs.ui.style.setProperty('--eltreecolor', this.$store.state.eltreecolor);
        this.$refs.ui.style.setProperty('--textcolor', this.$store.state.textcolor);
        this.$refs.ui.style.setProperty('--eltreebordercolor', this.$store.state.eltreebordercolor);
      },
    },

    methods: {
      syncGlobalPoint(){
        let typeValue = ''
        let flag = false
        let tempCheckedKeys = this.globalPointId.split(',')
        for(let i in tempCheckedKeys){
          for(let j in this.allPoints){
            if(this.allPoints[j].id == tempCheckedKeys[i]){
              typeValue = this.allPoints[j].type
              if(this.allPoints[j].cylinderNo >= 1 && this.allPoints[j].cylinderNo <= 100){
                this.treeData.type = "壳体振动"
              }else if(this.allPoints[j].cylinderNo == 0){
                this.treeData.type = "曲轴箱振动"
              }else if(this.allPoints[j].cylinderNo > 100){
                this.treeData.type = "其它振动"
              }
              flag = true
              break
            }
          }
          if(!flag){
            for(let i in tempCheckedKeys){
              for(let j in this.otherPoints){
                if(this.otherPoints[j].id == tempCheckedKeys[i]){
                  this.treeData.type = this.channelType[this.otherPoints[j].channelType]
                  break
                }
              }
            }
          }
        }
        this.setPointTree(this.treeData.type,typeValue)
      },
      getPointTree(equid) {
        const data = this.nodeData[equid];
        if (data === undefined)
          return;
        this.allPoints = [];
        this.otherPoints = [];
        for (var i = 0; i < data.length; ++i) {
          var nowjson = {};
          nowjson['id'] = data[i].pointId;
          nowjson['label'] = data[i].pointName;
          nowjson['channelType'] = data[i].channelType;
          nowjson['type'] = data[i].type;
          nowjson['cylinderNo'] = data[i].cylinderNo;
          if (data[i].channelType == 1) {
            this.allPoints.push(nowjson)
          } else {
            this.otherPoints.push(nowjson);
          }
        }
        this.syncGlobalPoint()
      },

      typeChange() {
        this.treeData.feature = 0;
        this.setPointTree(this.treeData.type);
      },

      setPointTree(type, typeValue = '') {
        this.first = true
        this.nowType = type;
        if(type == '') return
        const data = this.nodeData[this.equid];
        this.reciprocateTree = [];
        let channelType = 0;
        let Type = 0;
        switch (type) {
          case "壳体振动":
            channelType = 1;
            Type = 100;
            break;
          case "曲轴箱振动":
            channelType = 1;
            Type = 101;
            break;
          case "其它振动":
            channelType = 1;
            Type = 100;
            break;
          case "压力":
            channelType = 3;
            Type = 99;
            break;
          case "温度":
            channelType = 4;
            Type = 99;
            break;
          case "流量":
            channelType = 5;
            Type = 99;
            break;
          case "其它":
            channelType = 6;
            Type = 99;
            break;
          case "撞击":
            channelType = 7;
            Type = 99;
            break;
          case "动态压力":
            channelType = 11;
            Type = 111;
            break;
          case "活塞杆沉降/偏摆":
            channelType = 12;
            Type = 112;
            break;
        }

        this.treeData.channelType = channelType;

        let tree = [];
        tree = data.filter(item => item["channelType"] === channelType);
        if (channelType === 1) {
          if (type == "壳体振动") {
            tree = tree.filter(item => item["cylinderNo"] >= 1 && item["cylinderNo"] <= 100);
          } else if (type == "曲轴箱振动") {
            tree = tree.filter(item => item["cylinderNo"] == 0);
          }else{
            tree = tree.filter(item => item["cylinderNo"] > 100);
          }
        }
        tree = tree.map(item => {
          return {"id": item.pointId, "label": item.pointName, "type": item.type};
        });
        if (tree.length > 0) {
          this.reciprocateTree.push({'id': type, 'label': type, 'children': []});
          this.reciprocateTree[0].children = tree;
          if (Type !== 99) {
            this.treeData.Type = typeValue ? typeValue :  this.reciprocateTree[0].children[0].type
            this.reciprocateTree[0].children.unshift({'id': '特征', 'label': '特征', 'disabled': true, 'type': this.treeData.Type});
          }
        }

        this.$nextTick(() => {
          if(this.reciprocateTree[0]) {
            if(this.$store.state.globalPointId){
              let tempCheckedKeys = this.globalPointId.split(',')
              this.$refs.recComTree.setCheckedKeys(tempCheckedKeys);
              if(this.$refs.recComTree.getCheckedNodes().length) {
                this.$refs.recComTree.setChecked(this.reciprocateTree[0].children[0].id, true)
                this.pointTreeChecked();
              }else{
                if(Type !=99 ){
                  this.$refs.recComTree.setCheckedKeys([this.reciprocateTree[0].children[0].id,this.reciprocateTree[0].children[1].id]);
                }else{
                  this.$refs.recComTree.setCheckedKeys([this.reciprocateTree[0].children[0].id]);
                }
                this.pointTreeChecked();
              }
            }else{
              if(Type !=99 ){
                this.$refs.recComTree.setCheckedKeys([this.reciprocateTree[0].children[0].id,this.reciprocateTree[0].children[1].id]);
              }else{
                this.$refs.recComTree.setCheckedKeys([this.reciprocateTree[0].children[0].id]);
              }
              this.pointTreeChecked();
            }
          }
        });
      },

      pointTreeChecked(data) {
        if(data) {
          //全选
          if (data.hasOwnProperty('children')) {
            if (this.pointSelectList[data.id].length) {
              for (let i in data.children) {
                this.$refs.recComTree.setChecked(data.children[i].id, false);
              }
              this.pointSelectList[data.id] = []
            } else {
              let maxNumIndex = config.menu.MaxSelectedPointNumber
              if(data.children[0].label == '特征'){ //如果有特征测点，更新特征测点的type为第一个测点的type，根据最大测点选择数以及type选择测点
                data.children[0].type = data.children[1].type
                this.treeData.Type = data.children[1].type
                for(let i in data.children){
                  if(this.pointSelectList[data.id].length >= maxNumIndex || data.children[i].type != data.children[1].type) this.$refs.recComTree.setChecked(data.children[i].id, false);
                  else{
                    this.$refs.recComTree.setChecked(data.children[i].id, true);
                    if(data.children[i].label == '特征') continue
                    this.pointSelectList[data.id].push(data.children[i].id)
                  }
                }
              }else{ //没有特征测点，根据最大测点选择数控制测点
                for(let i in data.children){
                  if(this.pointSelectList[data.id].length >= maxNumIndex) this.$refs.recComTree.setChecked(data.children[i].id, false);
                  else{
                    this.$refs.recComTree.setChecked(data.children[i].id, true);
                    this.pointSelectList[data.id].push(data.children[i].id)
                  }
                }
              }
            }
          } else {//单选
            let maxNumIndex = config.menu.MaxSelectedPointNumber
            let parentData = this.$refs.recComTree.getNode(data.id).parent.data //根据所选测点获得父节点的data
            let index = this.pointSelectList[this.nowType].indexOf(data.id)
            this.$refs.recComTree.setChecked(data.id, index == -1);
            if(index == -1) {//选中
              this.pointSelectList[this.nowType].push(data.id)
              if(parentData.children[0].label == '特征') { //当前测点类型下有特征测点,选中特征测点，更新特征测点type为所选测点的type
                this.$refs.recComTree.setChecked(parentData.children[0].id, true);
                parentData.children[0].type = data.type
                this.treeData.Type = data.type
                this.pointSelectList[this.nowType] = this.pointSelectList[this.nowType].filter(item =>{
                  let tempNodeData = this.$refs.recComTree.getNode(item).data
                  if(tempNodeData.type != data.type){
                    this.$refs.recComTree.setChecked(item, false);
                  }
                  return tempNodeData.type == data.type
                })//不同type互斥
              }
              if (this.pointSelectList[this.nowType].length > maxNumIndex) {//根据最大测点选择数控制测点
                this.$refs.recComTree.setChecked(this.pointSelectList[this.nowType][0], false);
                this.pointSelectList[this.nowType].shift()
              }
            }else{//取消选中
              this.pointSelectList[this.nowType].splice(index, 1)
              if (this.pointSelectList[this.nowType].length == 0 && parentData.children[0].label == '特征') {
                this.$refs.recComTree.setChecked(parentData.children[0].id, false);
              }
            }
          }
        }
        var allnode = [];
        allnode['checkedNodes']= this.$refs.recComTree.getHalfCheckedNodes();
        allnode['featureSelect']= this.treeData.feature;
        allnode['Type']= this.treeData.Type;
        var checked = this.$refs.recComTree.getCheckedNodes();
        // 对于有特征结点的测点，选择一个子节点后，特征勾选，如果没有子节点，特征不勾选；没有特征结点的测点，无需进行这一步
        // if (checked.length > 0 && this.reciprocateTree[0].children[0].id == '特征'){
        //   if (checked.filter(item => item.id != '特征').length > 0){
        //     this.$refs.recComTree.setChecked(this.reciprocateTree[0].children[0].id, true);
        //   }else if (checked.filter(item => item.id != '特征').length == 0){
        //     this.$refs.recComTree.setChecked(this.reciprocateTree[0].children[0].id, false);
        //   }
        // }
        for (var i = 0; i < checked.length; ++i) {
          if (checked[i].label == "特征")
            continue;
          allnode['checkedNodes'].push(checked[i]);
        }
        if(this.first){
          this.first = false
          for(let i in this.pointSelectList){
            this.pointSelectList[i] = [];
          }
          allnode['checkedNodes'].forEach(item =>{
            if(!item.hasOwnProperty('children') && !item.hasOwnProperty('disabled')) {
              this.pointSelectList[this.nowType].push(item.id)
            }
          })
        }
        // console.log('iiiiiiiiiiiiii');
        // console.log(allnode)
        if (allnode.checkedNodes.length == 0) {
          this.$emit('getTreeData', allnode, true);
        } else {
          this.$emit('getTreeData', allnode, false);
        }
        let tempCheckedNodes = allnode['checkedNodes'].filter(item =>{
          return !item.hasOwnProperty('children') && !item.hasOwnProperty('disabled')
        })
        let ids = tempCheckedNodes.map(item => item.id);
        this.$store.state.globalPointId = ids.join(',');
        this.$store.state.pointId = this.$store.state.globalPointId
      },

      renderContent(h, {node, data, store}) {
        if (node.label === '特征') {
          return h("div",{class: "feature-content"}, [
            h("span", {
                  style: {
                    fontSize: '14px',
                    color: this.mycolor,
                    marginRight: '5px',
                    display: 'flex',
                    alignItems: 'center'
                  },
                }, this.translateText("textMap.","特征")),
            h("div",{class: "feature-select"},[
              h("el-select", {
                class: "el-select--mini el-input--mini",
                style: {
                  // width: '100%'
                },
                on: {
                  input: (value) => {
                    this.treeData.feature = value;
                    this.pointTreeChecked()
                  }
                },
                props: {
                  value:this.treeData.feature
                }
              }, [
                this.$store.state.features[node.data.type].map(item => {
                  return h("el-option", {
                      style: {
                        lineHeight: '18px',
                        fontSize: '14px',
                        height: '18px'
                      },
                      props: {
                        value: item.id,
                        label: this.translateText("textMap.",item.label)
                      }
                    }
                  );
                })
              ])]
            )
            ]
          );
        } else {
          return h("span", {
              style: {

                fontSize: '14px',
                color: this.mycolor
              },
            }, this.translateText("textMap.",node.label)
          );
        }
      }
    },
  }
</script>

<style lang="scss">

  .ReciprocatOverviewTree {
    --pointcolor: #1D1E2C;
    --eltreecolor: #1D1E2C;
    --textcolor: #ffffff;
    --eltreebordercolor: #000;
    //--input_width: 148px;
    height: 228px;
    width: calc(100% - 10px);
    overflow: auto;
    background-color: var(--eltreecolor);
    padding: 8px 0 8px 8px;
    border-radius: 6px;
    border: 1px solid var(--eltreebordercolor);

    .el-tree {
      background: var(--eltreecolor);
      .feature-content{
        display: flex;
        width: 182px;
      }
      .feature-select{
        //flex: 1;
      }

      .el-input {
        font-size: 14px;
        //width: var(--input_width);
      }

      .el-tree-node > .el-tree-node__content {
        background-color: var(--eltreecolor) !important;
      }

      .el-tree-node.is-current > .el-tree-node__content {
        background-color: var(--eltreecolor) !important;
      }

      .el-tree-node__content {
        height: auto;
        margin-right: 8px;
        margin-bottom: 8px;
      }

      .el-tree-node__content > .el-tree-node__expand-icon {
        padding: 6px 5.5px 5.5px 6px;
        width: 12.5px;
        height: 12.5px;
        font-size: 12.5px
      }

      .el-checkbox {
        height: 16px;
        padding: 4px;
        font-size: 14px;
        margin-right: 0;
      }

      .el-tree-node__label {
        font-size: 14px;
        padding: 0px 4px;
      }

      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: var(--eltreecolor) !important;
        border-color: var(--textcolor) !important;
      }

      //.el-checkbox__inner{
      //  background-color: var(--eltreecolor);
      //  border-color: var(--textcolor)
      //}

      .el-checkbox__input.is-disabled .el-checkbox__inner{
        background-color: var(--eltreecolor) !important;
        border-color: var(--textcolor) !important;
      }

      .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color: var(--textcolor);
      }
      .el-checkbox__inner::before{
        background-color: var(--textcolor);
      }

    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ReciprocatMachineryOverviewOpPage/ReciprocatOverviewTree.vue